import { createContext } from "react";
import { Function, Team } from "../types";

export declare type RankType = "team" | "crewlid" | "coordinator";
export declare type RankInfo = { type: RankType; id: number };
export declare type RankData = Team | Function;
export declare type QueryRankData = {
  isLoading: boolean;
  data?: RankData;
  toLabel: () => string;
} & RankInfo;

export declare type RankingContext = {
  first?: QueryRankData;
  second?: QueryRankData;
  third?: QueryRankData;
  setRank: (rank: 1 | 2 | 3, id: number, type?: RankType) => void;
};

export const rankingContext = createContext<RankingContext | undefined>(undefined);

export const typeToKey = {
  team: "name",
  crewlid: "title",
  coordinator: "title"
};

export const typeToPrefix: Record<string, string> = {
  team: "Team",
  crewlid: "Crewlid",
  coordinator: "Coördinator"
};




